import React, { useState, useEffect, useRef } from 'react';
import { BsThreeDotsVertical } from "react-icons/bs";

const AllCoins = () => {
  const [clients, setClients] = useState([
    { name: 'John Doe', coins: 50 },
    { name: 'Jane Smith', coins: 30 },
    { name: 'Alice Johnson', coins: 20 },
    { name: 'Bob Brown', coins: 15 },
  ]);

  const [editingClient, setEditingClient] = useState(null);
  const modalRef = useRef();

  const handleRemoveCoins = (client) => {
    setEditingClient(client);
  };

  const confirmRemoval = () => {
    setClients((prevClients) =>
      prevClients.filter((client) => client !== editingClient)
    );
    setEditingClient(null);
  };

  const closeModal = () => {
    setEditingClient(null);
  };

  // Handle Escape key press for closing modal
  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      closeModal();
    }
  };

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className="container mx-auto p-8 min-h-screen">
      <h1 className="text-3xl font-bold mb-6">All Coins</h1>

      {/* Coins Table */}
      {clients.length === 0 ? (
        <p className="text-center text-gray-400">No Clients Found</p>
      ) : (
        <table className="min-w-full bg-gray-800 text-white rounded-lg shadow-lg">
          <thead>
            <tr className="text-left border-b-2 border-gray-600">
              <th className="py-2 px-4">Client Name</th>
              <th className="py-2 px-4">Coins Received</th>
              <th className="py-2 px-4"></th>
            </tr>
          </thead>
          <tbody>
            {clients.map((client, index) => (
              <tr key={index} className="border-b border-gray-700">
                <td className="py-2 px-4">{client.name}</td>
                <td className="py-2 px-4">{client.coins}</td>
                <td className="py-2 px-4">
                  <div className="relative inline-block text-left">
                    <button
                      onClick={() => handleRemoveCoins(client)}
                      className="text-gray-400 hover:text-white"
                    >
                     <BsThreeDotsVertical />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Confirmation Modal for removing coins */}
      {editingClient && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div ref={modalRef} className="bg-gray-900 p-8 rounded-lg shadow-lg w-96">
            <h2 className="text-lg font-bold mb-4">Confirm Removal</h2>
            <p>Are you sure you want to remove coins from {editingClient.name}?</p>
            <div className="flex justify-end mt-4">
              <button 
                onClick={closeModal} 
                className="mr-4 bg-red-600 text-white px-4 py-2 rounded-lg"
              >
                Cancel
              </button>
              <button 
                onClick={confirmRemoval} 
                className="bg-green-600 text-white px-4 py-2 rounded-lg"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllCoins;
